import { render, staticRenderFns } from "./QuickInfoSection.vue?vue&type=template&id=1b58920f&scoped=true&"
import script from "./QuickInfoSection.vue?vue&type=script&lang=js&"
export * from "./QuickInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./QuickInfoSection.vue?vue&type=style&index=0&id=1b58920f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b58920f",
  null
  
)

export default component.exports